/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestCheckpointMessageSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTO_TEST_CHECKPOINT_MESSAGE')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecString)],
]);
export class AutoTestCheckpointMessageSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestCheckpointMessageSettingParser.decode(input).map(res => new AutoTestCheckpointMessageSetting(res));
    }
    static unsafeDecode(input) {
        return AutoTestCheckpointMessageSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestCheckpointMessageSettingParser.encode(data);
    }
    static schema() {
        return AutoTestCheckpointMessageSettingParser.schema();
    }
}
